import React from "react";
import Buttons from "../Componets/Buttons";
import Code from "../Componets/Code";
function Home() {
  return (
    <div className="Home">
      <div className="display">
        <div className="buttons">
          <Buttons />
        </div>
        <Code />
      </div>
    </div>
  );
}

export default Home;
